var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumb',{style:({ margin: '20px 10px' })},[_c('BreadcrumbItem',[_vm._v("角色管理")]),_c('BreadcrumbItem',[_vm._v("添加角色")])],1),_c('loading',{attrs:{"loading":_vm.loading,"error":_vm.error}}),_c('formPage',{attrs:{"role":_vm.role},on:{"handleSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }